const o = (e) => e.isAuthenticated, i = (e) => !!e.isGuest, l = (e) => e.status, u = (e) => e.userId, a = (e) => {
  var t;
  return (t = n(e)) == null ? void 0 : t.firstName;
}, d = (e) => e.roles, U = (e) => (t) => {
  var s;
  return !!((s = t.roles) != null && s[e]);
}, C = (e) => (t) => {
  var s;
  return !!((s = t.roles) != null && s[e]);
}, n = (e) => e.currentUser, b = (e) => {
  const { accessToken: t, refreshToken: s, expires: c } = e;
  return { accessToken: t, refreshToken: s, expires: c };
}, h = (e) => e.accessToken, m = (e) => e.agentId, A = (e) => {
  var t;
  return (t = n(e)) == null ? void 0 : t.id;
}, I = (e) => {
  var t;
  return (t = n(e)) == null ? void 0 : t.customerID;
}, g = (e) => {
  var t;
  return (t = n(e)) == null ? void 0 : t.email;
}, r = (e) => {
  var t;
  return (t = n(e)) == null ? void 0 : t.notificationSettings;
}, f = (e) => {
  var t;
  return (t = n(e)) == null ? void 0 : t.onboarding;
}, S = (e) => {
  var t;
  return (t = n(e)) == null ? void 0 : t.subscriptionPlan;
}, k = (e) => {
  var t;
  return (t = n(e)) == null ? void 0 : t.team;
}, T = (e) => {
  var t;
  return (t = r(e)) == null ? void 0 : t.isPushNotificationEnabledGlobal;
}, E = (e) => {
  var t;
  return (t = r(e)) == null ? void 0 : t.isEmailNotificationEnabledGlobal;
}, N = (e) => {
  var s;
  const t = n(e);
  if (t)
    return (s = t.lobbies) == null ? void 0 : s[0];
}, p = (e) => {
  const t = n(e);
  return e.status === "initialized" && !!t;
};
export {
  C as makeSelectAuthHasRole,
  m as selectAgentId,
  h as selectAuthAccessToken,
  U as selectAuthHasRole,
  d as selectAuthRoles,
  l as selectAuthStatus,
  b as selectAuthToken,
  u as selectAuthUserId,
  n as selectCurrentUser,
  I as selectCurrentUserCustomerId,
  g as selectCurrentUserEmail,
  E as selectCurrentUserEmailSetting,
  a as selectCurrentUserFirstName,
  A as selectCurrentUserId,
  N as selectCurrentUserLobby,
  r as selectCurrentUserNotificationSettings,
  f as selectCurrentUserOnboarding,
  T as selectCurrentUserPushSetting,
  S as selectCurrentUserSubscriptionPlan,
  k as selectCurrentUserTeam,
  o as selectIsAuthenticated,
  i as selectIsCurrentUserGuest,
  p as selectIsCurrentUserLoaded
};
